import cn from 'classnames'
import clr from 'color'
import type { FC, ReactNode } from 'react'
import React, { useMemo } from 'react'

import styles from './CardTitle.module.css'

type Props = {
  color?: '#ffffff' | string
  fontColor?: '#ffffff' | string
  label?: ReactNode
  className?: string
}

const CardTitle: FC<Props> = ({ color, fontColor, label, className }) => {
  const titleStyle = useMemo(() => {
    if (!fontColor && !color) {
      return {}
    }

    return {
      color: fontColor || clr(color).darken(0.65).rgb().string()
    }
  }, [color, fontColor])

  return (
    <div
      style={titleStyle}
      className={cn(className, styles.Title)}
      data-testid='card-title'
    >
      {label}
    </div>
  )
}

export default CardTitle
